// extracted by mini-css-extract-plugin
export default {"bio":"About_bio__fsg7d","bio_up":"About_bio_up__KeBnb","bio_down":"About_bio_down__4ptnw","signature_text":"About_signature_text__soCtU"};